import { ParseConsistentBase64JsonPayloadUseCase } from '../Utils/ParseConsistentBase64JsonPayload';
export class AsymmetricSignatureVerificationDetached004 {
    constructor(crypto) {
        this.crypto = crypto;
        this.parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
    }
    execute(dto) {
        const [_, __, ciphertext, additionalDataString] = dto.encryptedString.split(':');
        const additionalData = this.parseBase64Usecase.execute(additionalDataString);
        try {
            const signatureVerified = this.crypto.sodiumCryptoSignVerify(ciphertext, additionalData.signingData.signature, additionalData.signingData.publicKey);
            return {
                signatureVerified,
                signaturePublicKey: additionalData.signingData.publicKey,
                senderPublicKey: additionalData.senderPublicKey,
            };
        }
        catch {
            return {
                signatureVerified: false,
            };
        }
    }
}
